/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-06-17 14:41:55
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-06-17 14:45:10
 * @FilePath: /unifyxp-v2-store-portal/src/components/LinkModule/Components/Head/index.tsx
 */
import { getI18nFromGeneral } from '@/src/tools/tools';
import React from 'react';
import styles from './style.module.less';

function Head({ title, count }) {
  return (
    <div className={styles.container}>
      <span>{title}</span>
      <span>{`${count} ${getI18nFromGeneral(
        'general.linkModule.Components.Head.items',
      )}`}</span>
    </div>
  );
}

export default Head;
